import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { WcGridModule } from '../../components/wc-grid/wc-grid.module';
import { ModelsSchemaDetailComponent } from './models-schema-detail.component';
import { ModelsUnitSetDetailComponent } from './models-unit-set-detail.component';

@Component({
  selector: 'app-models-editor',
  standalone: true,
  templateUrl: './models-editor.component.html',
  styleUrls: ['./models-editor.component.css'],
  imports: [CommonModule, MatTabsModule, WcGridModule, ModelsSchemaDetailComponent, ModelsUnitSetDetailComponent],
})
export class ModelsEditorComponent {
  selectedSchema: { id: string; name: string } | null = null;
  selectedUnitSet: { id: string; name: string } | null = null;

  readonly schemaRowActions = [{ id: 'open', label: 'Manage Tables & Foreign Keys' }];
  readonly unitSetRowActions = [{ id: 'editUnits', label: 'Edit Units' }];

  openSchema(event: { id: string; row: Record<string, any> }): void {
    if (event.id !== 'open') return;
    this.selectedSchema = { id: event.row['Id'], name: event.row['Name'] };
  }

  closeSchema(): void {
    this.selectedSchema = null;
  }

  openUnitSet(event: { id: string; row: Record<string, any> }): void {
    if (event.id !== 'editUnits') return;
    this.selectedUnitSet = { id: event.row['Id'], name: event.row['Name'] };
  }

  closeUnitSet(): void {
    this.selectedUnitSet = null;
  }
}
